import { useCallback, useEffect, useState } from 'react';
import { useLocalMedia, useLocalMediaActions } from '../../hooks';

type UseRequestVideo = {
  isVideoRequested: boolean;
  isAccessRequesting: boolean;
  onGiveAccess: () => void;
};
/**
 * Automatically enables / disables the local media based on argument.
 */
export const useRequestVideo = (enabled = true): UseRequestVideo => {
  const { init, start, stop } = useLocalMediaActions();
  const { hasVideoAccess, hasVideo } = useLocalMedia();

  const [isVideoRequested, setIsVideoRequested] = useState(false);
  const [isAccessRequesting, setIsAccessRequesting] = useState(false);

  useEffect(() => {
    if (enabled) {
      void init();
    } else {
      void stop();
    }
  }, [enabled]);

  const requestVideo = useCallback(async () => {
    setIsVideoRequested(true);
    setIsAccessRequesting(true);
    await start();
    setIsAccessRequesting(false);
  }, [start]);

  useEffect(() => {
    if (enabled && hasVideoAccess && !hasVideo && !isVideoRequested) {
      void requestVideo();
    }
  }, [hasVideo, hasVideoAccess, isVideoRequested, requestVideo, enabled]);

  const onGiveAccess = useCallback(() => {
    void requestVideo();
  }, [requestVideo]);

  return {
    isVideoRequested,
    isAccessRequesting,
    onGiveAccess,
  };
};
